import React from "react";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import { Link } from "react-router-dom";

const footerLinks = [
  {
    heading: "Company",
    links: [
      { to: "/about", text: "About Us" },
      { to: "/careers", text: "Careers" },
      { to: "/blog", text: "Blog" },
      { to: "/team", text: "Our Team" },
      { to: "/history", text: "Our History" },
      { to: "/mission", text: "Our Mission" },
    ],
  },
  {
    heading: "Product",
    links: [
      { to: "/features", text: "Features" },
      { to: "/pricing", text: "Pricing" },
      { to: "/demo", text: "Demo" },
      { to: "/integrations", text: "Integrations" },
      { to: "/api", text: "API" },
      { to: "/mobile", text: "Mobile App" },
    ],
  },
  {
    heading: "Resources",
    links: [
      { to: "/docs", text: "Documentation" },
      { to: "/support", text: "Support" },
      { to: "/community", text: "Community" },
      { to: "/guides", text: "Guides" },
      { to: "/tutorials", text: "Tutorials" },
      { to: "/webinars", text: "Webinars" },
    ],
  },
  {
    heading: "Legal",
    links: [
      { to: "/terms", text: "Terms of Service" },
      { to: "/privacy", text: "Privacy Policy" },
      { to: "/security", text: "Security" },
      { to: "/compliance", text: "Compliance" },
      { to: "/licenses", text: "Licenses" },
      { to: "/disclaimer", text: "Disclaimer" },
    ],
  },
  {
    heading: "Social",
    links: [
      { to: "/contact", text: "Contact Us" },
      { to: "/support", text: "Support" },
      { to: "/faq", text: "FAQ" },
      { to: "/facebook", text: "Facebook" },
      { to: "/twitter", text: "Twitter" },
      { to: "/linkedin", text: "LinkedIn" },
    ],
  },
];

const Footer = () => {
  return (
    <footer className="footer body-font py-5">
      <Container>
        <Row className="align-items-center my-4">
          <Col md={6}>
            <h5 className="fs-two fw-bold">Join our newsletter</h5>
            <p className="gray-color">
              We’ll send you a nice letter once per week. No spam.
            </p>
          </Col>
          <Col md={6} className="d-flex justify-content-md-end">
            <Form className="d-flex w-100">
              <Form.Control
                type="email"
                placeholder="Enter your email"
                className="me-2"
              />
              <Button
                className="btn-primary-style fs-one fw-bold"
                as={Link}
                to=""
              >
                Subscribe
              </Button>
            </Form>
          </Col>
        </Row>
        <hr className="border-dark-subtle mt-5" />
        <Row className="mt-5">
          {footerLinks.map((section, index) => (
            <Col md={2} key={index} className="mx-3">
              <h6 className="fw-bold fs-one gray-color">{section.heading}</h6>
              <ul className="list-unstyled">
                {section.links.map((link, idx) => (
                  <li key={idx}>
                    <Link
                      to={link.to}
                      className="text-decoration-none gray-color"
                    >
                      {link.text}
                    </Link>
                  </li>
                ))}
              </ul>
            </Col>
          ))}
        </Row>
        <hr className="border-dark-subtle" />
        <Row className="mt-5 align-items-center">
          <Col className="d-flex justify-content-between align-items-center">
            <Link
              to="/"
              className="purple-color righteousy-font fs-5 text-decoration-none"
            >
              <span className="fs-four-title">Nouraa</span>
              <span className="fs-two">.ai</span>
            </Link>
            <p className="mb-0 gray-color text-end">
              &copy; {new Date().getFullYear()} Nouraa AI. All rights reserved.
            </p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
